import { ChevronRight } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useSession, useSettings } from '@/auth/useSession';
import { Button, Card, CardTitle, Field, Input, PageHeader, Segmented } from '@/components/ui';
import { useSaveTenant } from './useTenantSettings';

/** Screen 25 — Settings (owner, PL-6): farm name, default language and calendar, and links to the other settings. */
export function SettingsPage() {
  const { t } = useTranslation();
  const session = useSession();
  const s = useSettings();
  const { saveTenant, saving } = useSaveTenant();
  const [name, setName] = useState(session.profile?.tenantName ?? '');
  const [locale, setLocale] = useState(s.defaultLocale);
  const [calendar, setCalendar] = useState(s.defaultCalendar);
  const links = [
    ['/settings/sessions', t('settings.sessions')],
    ['/settings/breeding', t('settings.breeding')],
    ['/settings/protocols', t('settings.protocols')],
    ['/settings/categories', t('settings.categories')],
    ['/settings/users', t('settings.users')],
    ['/expenses/recurring', t('recurring.title')],
  ];
  return (
    <div className="mx-auto max-w-lg space-y-4">
      <PageHeader title={t('settings.title')} />
      <Card className="space-y-4">
        <CardTitle>{t('settings.farm')}</CardTitle>
        <Field label={t('settings.farmName')}>
          <Input value={name} onChange={(e) => setName(e.target.value)} maxLength={80} />
        </Field>
        <Field label={t('settings.defaultLanguage')}>
          <Segmented value={locale} onChange={setLocale} options={[{ value: 'am', label: 'አማርኛ' }, { value: 'en', label: 'English' }]} />
        </Field>
        <Field label={t('settings.defaultCalendar')}>
          <Segmented value={calendar} onChange={setCalendar} options={[{ value: 'EC', label: t('date.ecLong') }, { value: 'GC', label: t('date.gcLong') }]} />
        </Field>
        <Button disabled={saving} onClick={() => void saveTenant({ name: name.trim(), settings: { defaultLocale: locale, defaultCalendar: calendar } })}>
          {t('common.save')}
        </Button>
      </Card>
      <Card className="p-0">
        <ul className="divide-y divide-stone-100">
          {links.map(([to, label]) => (
            <li key={to}>
              <Link to={to!} className="flex min-h-14 items-center justify-between px-4 font-medium">
                {label}
                <ChevronRight className="h-5 w-5 text-stone-400" />
              </Link>
            </li>
          ))}
        </ul>
      </Card>
    </div>
  );
}
